/* ONX Customs v4 — CRO-optimised Theme JS */
(function(){
'use strict';

/* ── CART ENGINE ──────────────────────────────── */
var Cart={
  thresh:(window.ONX&&window.ONX.thresh||150)*100,
  init:function(){
    var s=this;
    s.drawer=document.getElementById('cdw');
    s.overlay=document.getElementById('cov');
    s.itemsEl=document.getElementById('citems');
    s.totalEl=document.getElementById('ctotal');
    s.fillEl=document.getElementById('shipfill');
    s.shipTxt=document.getElementById('shiptxt');
    // Open triggers
    document.querySelectorAll('[data-oc]').forEach(function(b){b.addEventListener('click',function(){s.open()})});
    var cl=document.getElementById('cdw-close');
    if(cl)cl.addEventListener('click',function(){s.close()});
    if(s.overlay)s.overlay.addEventListener('click',function(){s.close()});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')s.close()});
    document.addEventListener('cart:refresh',function(){s.refresh()});
    // Init count
    s.fetchCount();
  },
  fetchCount:function(){
    var s=this;
    fetch('/cart.js').then(function(r){return r.json()}).then(function(c){s.updateCount(c.item_count)}).catch(function(){});
  },
  open:function(){
    if(this.drawer)this.drawer.classList.add('open');
    if(this.overlay)this.overlay.classList.add('open');
    document.body.style.overflow='hidden';
    var tt=document.getElementById('atc-toast');if(tt)tt.classList.remove('show');
    this.refresh();
  },
  close:function(){
    if(this.drawer)this.drawer.classList.remove('open');
    if(this.overlay)this.overlay.classList.remove('open');
    document.body.style.overflow='';
  },
  refresh:function(){
    var s=this;
    fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
      s.updateCount(c.item_count);
      s.updateShip(c.total_price);
      s.renderItems(c.items);
      s.updateTotal(c.total_price);
      s.toggleFooter(c.item_count);
      Upsell.renderCart(c);
    }).catch(function(e){console.warn('Cart refresh failed',e)});
  },
  toggleFooter:function(n){
    var show=n>0?'':'none';
    var ftr=document.querySelector('.cdw__ftr');
    if(ftr)ftr.style.display=show;
    // Express wallet buttons are rendered on every page now; show them once there's
    // something to buy. Previously they were absent entirely on empty-cart page loads.
    var exp=document.getElementById('cdw-express');
    if(exp)exp.hidden=!(n>0);
  },
  updateCount:function(n){
    document.querySelectorAll('[data-cc]').forEach(function(el){
      el.textContent=n;
      // Only the round header badge toggles visibility; inline title counts stay inline
      if(el.classList.contains('cbadge'))el.style.display=n>0?'flex':'none';
    });
  },
  /* A free-shipping code won on the wheel is applied to the session, but Shopify
     doesn't surface shipping discounts in /cart.js — they only appear at checkout.
     The wheel records the win locally, so read that and reflect it in the bar. */
  spinFreeShip:function(){
    try{ return !!(JSON.parse(localStorage.getItem('onx_spin_v2')||'{}').freeShip); }
    catch(e){ return false; }
  },
  updateShip:function(cents){
    var aunz=window.ONX&&window.ONX.aunz;
    if(this.spinFreeShip()){
      if(this.shipTxt)this.shipTxt.innerHTML='<strong>Free shipping unlocked \ud83c\udf89</strong>';
      if(this.fillEl)this.fillEl.style.width='100%';
      this.updateNote(cents,aunz);
      return;
    }
    if(this.shipTxt){
      if(!aunz){this.shipTxt.innerHTML='Shipping calculated at checkout';}
      else{
        var rem=this.thresh-cents;
        if(rem<=0){this.shipTxt.innerHTML='<strong>You\'ve unlocked FREE shipping! 🎉</strong>';}
        else{this.shipTxt.innerHTML='You\'re <strong>'+this.fmt(rem)+'</strong> away from free shipping 🇦🇺';}
      }
    }
    if(this.fillEl){this.fillEl.style.width=aunz?Math.min(100,cents/this.thresh*100)+'%':'0%';}
    this.updateNote(cents,aunz);
  },
  updateNote:function(cents,aunz){
    var note=document.getElementById('cdw-shipnote');
    if(!note)return;
    if(this.spinFreeShip()){
      note.innerHTML='\u2713 Free shipping unlocked \u2014 apply your code at checkout';
      note.style.color='#16a34a';
      return;
    }
    if(!aunz){note.innerHTML='+ shipping &amp; taxes calculated at checkout';note.style.color='var(--muted)';return;}
    var rem=this.thresh-cents;
    if(rem>0){note.innerHTML='Add '+this.fmt(rem)+' more for FREE shipping 🇦🇺';note.style.color='var(--accent)';}
    else{note.innerHTML='✓ FREE shipping unlocked — AUS &amp; NZ';note.style.color='#16a34a';}
  },
  updateTotal:function(c){if(this.totalEl)this.totalEl.textContent=this.fmt(c);var co=document.getElementById('co-amt');if(co)co.textContent=this.fmt(c);},
  renderItems:function(items){
    if(!this.itemsEl)return;
    if(!items.length){
      this.itemsEl.innerHTML='<div style="text-align:center;padding:52px 16px"><p style="font-family:var(--head);font-weight:900;font-size:19px;text-transform:uppercase;margin-bottom:8px">Your cart is empty</p><p style="font-size:14px;color:var(--muted);margin-bottom:24px">Find parts engineered for your bike.</p><a href="/collections/all" class="btn btn--dk btn--sm" onclick="Cart.close()">Shop All Parts</a></div>';
      return;
    }
    this.itemsEl.innerHTML=items.map(function(it){
      var saveLine='';
      if(it.compare_at_price&&it.compare_at_price>it.price){
        var sav=it.compare_at_price-it.price;
        if(sav>0)saveLine='<div style="font-size:10px;color:var(--accent);font-family:var(--head);font-weight:700;letter-spacing:.06em;text-transform:uppercase;margin-top:2px">Save '+Cart.fmt(sav)+'</div>';
      }
      return '<div class="ci" data-key="'+it.key+'"><img class="ci__img" src="'+it.image+'" alt="'+it.product_title+'" loading="lazy"><div><div class="ci__name">'+it.product_title+'</div>'+(it.variant_title&&it.variant_title!=='Default Title'?'<div class="ci__var">'+it.variant_title+'</div>':'')+saveLine+'<div class="ci__row"><div class="qc"><button class="qb" data-a="dec" data-key="'+it.key+'" data-q="'+it.quantity+'">−</button><span class="qn">'+it.quantity+'</span><button class="qb" data-a="inc" data-key="'+it.key+'" data-q="'+it.quantity+'">+</button><button class="qb" data-a="rm" data-key="'+it.key+'" style="margin-left:4px;font-size:11px">✕</button></div><span class="ci__price">'+Cart.fmt(it.final_line_price)+'</span></div></div></div>';
    }.bind(this)).join('');
    var s=this;
    this.itemsEl.querySelectorAll('[data-a]').forEach(function(b){
      b.addEventListener('click',function(){
        var a=b.dataset.a,k=b.dataset.key,q=parseInt(b.dataset.q);
        if(a==='inc')s.changeQty(k,q+1);
        if(a==='dec')s.changeQty(k,Math.max(0,q-1));
        if(a==='rm')s.changeQty(k,0);
      });
    });
  },
  changeQty:function(key,qty){
    var s=this;
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(){s.refresh();}).catch(function(){});
  },
  fmt:function(c){return'$'+(c/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');}
};

/* ── ADD TO CART ──────────────────────────────── */
var ATC={
  init:function(){
    document.addEventListener('click',function(e){
      var btn=e.target.closest('[data-atc]');
      if(!btn)return;
      e.preventDefault();
      ATC.add(btn);
    });
    var form=document.getElementById('pform');
    if(form){
      form.addEventListener('submit',function(e){
        e.preventDefault();
        var b=form.querySelector('[data-atc]');
        if(b)ATC.add(b);
      });
    }
  },
  add:function(btn){
    // Get id from button data-id or from hidden form input
    var id=btn.dataset.id;
    if(!id){
      var form=btn.closest('form')||document.getElementById('pform');
      var inp=form&&form.querySelector('[name="id"]');
      id=inp&&inp.value;
    }
    if(!id)return;
    var orig=btn.innerHTML;
    btn.disabled=true;
    btn.innerHTML='<span style="opacity:.6">Adding...</span>';
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:parseInt(id),quantity:1})
    }).then(function(r){
      if(!r.ok)throw new Error('OOS');
      btn.innerHTML='✓ Added';
      document.dispatchEvent(new CustomEvent('cart:refresh')); // update badge + drawer contents without opening
      Toast.show();
      setTimeout(function(){btn.innerHTML=orig;btn.disabled=false;},2400);
    }).catch(function(e){
      btn.innerHTML=e.message==='OOS'?'Out of Stock':'Error — try again';
      setTimeout(function(){btn.innerHTML=orig;btn.disabled=false;},2400);
    });
  }
};

/* ── UPSELLS ──────────────────────────────────────
   Two surfaces, one pool:
   - Cart drawer: picks add-ons that close the free-shipping gap, re-run on every
     cart change. Skips anything already in the cart.
   - Product page: server-renders a fallback, then swaps in Shopify's own
     complementary products when the merchant has set them in Search & Discovery.
*/
var Upsell={
  pool:[], cartMax:4,
  init:function(){
    var el=document.getElementById('ups-pool');
    if(el){
      try{ this.pool=JSON.parse(el.textContent)||[]; }
      catch(e){ this.pool=[]; console.warn('Upsell pool parse failed',e); }
    }
    this.enhancePDP();
  },
  fmt:function(c){return Cart.fmt(c);},

  /* Choose up to cartMax add-ons given the live cart. */
  pick:function(cart){
    var inCart={};
    (cart.items||[]).forEach(function(i){ inCart[i.product_id]=true; });
    var avail=this.pool.filter(function(p){ return !inCart[p.pid]; });
    if(!avail.length) return {items:[],reason:''};

    var aunz=window.ONX&&window.ONX.aunz;
    var gap=aunz?(Cart.thresh-cart.total_price):0;

    if(gap>0){
      // Cheapest single item that gets them over the line, if one exists.
      var closers=avail.filter(function(p){ return p.price>=gap; })
                       .sort(function(a,b){ return a.price-b.price; });
      if(closers.length){
        var rest=avail.filter(function(p){ return p.pid!==closers[0].pid; })
                      .sort(function(a,b){ return a.price-b.price; });
        return {items:[closers[0]].concat(rest.slice(0,this.cartMax-1)),
                reason:'Add '+this.fmt(gap)+' more to unlock free shipping'};
      }
      // Nothing closes it alone — offer the cheapest, they still narrow the gap.
      return {items:avail.sort(function(a,b){return a.price-b.price;}).slice(0,this.cartMax),
              reason:'Add '+this.fmt(gap)+' more to unlock free shipping'};
    }
    return {items:avail.sort(function(a,b){return a.price-b.price;}).slice(0,this.cartMax),reason:''};
  },

  row:function(p){
    var cmp = (p.cmp&&p.cmp>p.price) ? '<s class="ups__was">'+this.fmt(p.cmp)+'</s>' : '';
    var img = p.img ? '<img src="'+p.img+'" alt="" loading="lazy" width="64" height="64">' : '';
    var act = p.multi
      ? '<a href="'+p.url+'" class="ups__add">Options</a>'
      : '<button type="button" class="ups__add" data-atc data-id="'+p.vid+'">+ Add</button>';
    return '<div class="ups__item" data-ups-pid="'+p.pid+'">'+
             '<a href="'+p.url+'" class="ups__img" tabindex="-1" aria-hidden="true">'+img+'</a>'+
             '<div class="ups__body">'+
               '<a href="'+p.url+'" class="ups__title">'+p.title+'</a>'+
               '<span class="ups__price">'+this.fmt(p.price)+cmp+'</span>'+
             '</div>'+act+
           '</div>';
  },

  renderCart:function(cart){
    var wrap=document.getElementById('ups-cart');
    var list=document.getElementById('ups-cart-list');
    var lbl=document.getElementById('ups-cart-label');
    if(!wrap||!list)return;
    if(!cart.item_count||!this.pool.length){ wrap.hidden=true; return; }
    var res=this.pick(cart);
    if(!res.items.length){ wrap.hidden=true; return; }
    list.innerHTML=res.items.map(this.row.bind(this)).join('');
    if(lbl&&res.reason) lbl.textContent=res.reason;
    wrap.hidden=false;
  },

  /* Swap the server-rendered fallback for Shopify's complementary products. */
  enhancePDP:function(){
    var box=document.getElementById('ups-pdp');
    if(!box)return;
    var pid=box.dataset.upsProduct, lim=box.dataset.upsLimit||3;
    if(!pid)return;
    fetch('/recommendations/products.json?product_id='+pid+'&limit='+lim+'&intent=complementary')
      .then(function(r){ return r.ok?r.json():null; })
      .then(function(d){
        if(!d||!d.products||!d.products.length)return;   // keep the fallback
        var list=document.getElementById('ups-pdp-list');
        if(!list)return;
        list.innerHTML=d.products.filter(function(p){return p.available;}).map(function(p){
          return Upsell.row({
            pid:p.id, vid:(p.variants[0]||{}).id, title:p.title, price:p.price,
            cmp:p.compare_at_price||0, url:p.url,
            img:p.featured_image?p.featured_image.replace(/(\.[a-z]+)(\?|$)/i,'_160x$1$2'):'',
            multi:p.variants.length>1
          });
        }).join('');
      })
      .catch(function(){});   // network failure just leaves the fallback in place
  }
};

/* ── ADD-TO-CART TOAST ────────────────────────── */
var Toast={
  el:null,_t:null,
  init:function(){ this.el=document.getElementById('atc-toast'); },
  show:function(){
    if(!this.el)this.el=document.getElementById('atc-toast');
    if(!this.el)return;
    var el=this.el;
    el.classList.add('show');
    clearTimeout(this._t);
    this._t=setTimeout(function(){ el.classList.remove('show'); },2800);
  }
};

/* ── MOBILE NAV ───────────────────────────────── */
var MNav={
  nav:null,
  open:function(){
    if(!this.nav)return;
    // Span the full screen height (top:0 + bottom:0 avoids dvh/vh gaps on mobile)
    this.nav.style.top='0';
    this.nav.style.bottom='0';
    this.nav.style.height='auto';
    var ov=document.getElementById('mnav-ov');
    if(ov){ov.style.top='0';ov.classList.add('open');}
    this.nav.classList.add('open');
    document.body.style.overflow='hidden';
  },
  close:function(){
    if(!this.nav)return;
    this.nav.classList.remove('open');
    this.nav.style.top='';
    this.nav.style.bottom='';
    this.nav.style.height='';
    var ov=document.getElementById('mnav-ov');
    if(ov){ov.classList.remove('open');ov.style.top='';}
    document.body.style.overflow='';
  },
  init:function(){
    var self=this;
    self.nav=document.getElementById('mnav');
    var tog=document.getElementById('mbtn');
    var cls=document.getElementById('mnav-close');
    var ov=document.getElementById('mnav-ov');
    if(tog)tog.addEventListener('click',function(e){e.stopPropagation();self.open();});
    if(cls)cls.addEventListener('click',function(){self.close();});
    var pull=document.getElementById('mnav-pull-close');
    if(pull)pull.addEventListener('click',function(){self.close();});
    if(ov)ov.addEventListener('click',function(){self.close();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')self.close();});
    /* Accordion: only one section open at a time. With three dropdowns the menu
       could otherwise run to ~1400px of scrolling on a phone. Also scrolls the
       section it just opened into view, since opening the last one used to push
       its contents below the fold. */
    if(self.nav){
      var drops=Array.prototype.slice.call(self.nav.querySelectorAll('.mnav__drop'));
      drops.forEach(function(d){
        d.addEventListener('toggle',function(){
          if(!d.open)return;
          drops.forEach(function(o){ if(o!==d) o.open=false; });
          var links=self.nav.querySelector('.mnav__links');
          if(!links)return;
          // Wait for the browser to lay the panel out before measuring
          requestAnimationFrame(function(){
            var top=d.offsetTop, bottom=top+d.offsetHeight;
            if(bottom > links.scrollTop + links.clientHeight){
              links.scrollTo({ top: Math.max(0, bottom - links.clientHeight + 12), behavior:'smooth' });
            }
          });
        });
      });
    }

    if(self.nav){
      var sx=0;
      self.nav.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
      self.nav.addEventListener('touchend',function(e){
        if(e.changedTouches[0].clientX-sx<-50)self.close();
      },{passive:true});
      var links=self.nav.querySelector('.mnav__links');
      if(links){
        links.addEventListener('touchstart',function(e){e.stopPropagation();},{passive:true});
        links.addEventListener('touchmove',function(e){e.stopPropagation();},{passive:true});
      }
    }
  }
};

/* ── DESKTOP NAV DROPDOWNS ────────────────────────
   "Shop By Bike" and "E-Moto Brakes" are <button>s with no href, and the menu
   opened only via CSS :hover / :focus-within. On touchscreen laptops and hybrid
   pointer devices that meant tapping them did nothing at all — two of six primary
   nav categories were dead with no link to fall back on. Adds click toggling,
   real aria-expanded state, outside-click and Escape.
*/
var NavDrop={
  init:function(){
    var drops=Array.prototype.slice.call(document.querySelectorAll('.nav__drop'));
    if(!drops.length)return;
    function closeAll(except){
      drops.forEach(function(d){
        if(d===except)return;
        d.classList.remove('open');
        var b=d.querySelector('.nav__drop-btn');
        if(b)b.setAttribute('aria-expanded','false');
      });
    }
    drops.forEach(function(d){
      var btn=d.querySelector('.nav__drop-btn');
      if(!btn)return;
      btn.addEventListener('click',function(e){
        e.preventDefault();
        e.stopPropagation();
        var willOpen=!d.classList.contains('open');
        closeAll(d);
        d.classList.toggle('open',willOpen);
        btn.setAttribute('aria-expanded',willOpen?'true':'false');
      });
      // Pointer users still get hover; keep the class in step so state is consistent
      d.addEventListener('mouseleave',function(){
        d.classList.remove('open');
        btn.setAttribute('aria-expanded','false');
      });
    });
    document.addEventListener('click',function(e){
      if(!e.target.closest('.nav__drop'))closeAll(null);
    });
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape')closeAll(null);
    });
  }
};

/* ── SCROLL REVEAL ────────────────────────────── */
var Reveal={
  init:function(){
    if(!('IntersectionObserver' in window)){
      document.querySelectorAll('.rv-anim').forEach(function(e){e.classList.add('vis')});
      return;
    }
    var obs=new IntersectionObserver(function(entries){
      entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('vis');obs.unobserve(e.target);}});
    },{threshold:.08,rootMargin:'0px 0px -24px 0px'});
    document.querySelectorAll('.rv-anim').forEach(function(el){obs.observe(el);});
  }
};

/* ── DRAG SCROLL (reviews carousel) ──────────── */
function dragScroll(el){
  if(!el)return;
  var down=false,sx,sl;
  el.addEventListener('mousedown',function(e){down=true;el.style.cursor='grabbing';sx=e.pageX-el.offsetLeft;sl=el.scrollLeft;});
  el.addEventListener('mouseleave',function(){down=false;el.style.cursor='grab';});
  el.addEventListener('mouseup',function(){down=false;el.style.cursor='grab';});
  el.addEventListener('mousemove',function(e){if(!down)return;e.preventDefault();el.scrollLeft=sl-(e.pageX-el.offsetLeft-sx)*1.4;});
}

/* ── INIT ─────────────────────────────────────── */
document.addEventListener('DOMContentLoaded',function(){
  Cart.init();
  ATC.init();
  Toast.init();
  Upsell.init();
  MNav.init();
  NavDrop.init();
  Reveal.init();
  document.querySelectorAll('.rv-scroll').forEach(dragScroll);
});

/* Expose Cart.close for inline onclick in empty cart state */
window.Cart=Cart;

})();
